import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles, Box } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  visuallyHidden: {
    position: 'absolute',
    left: theme.spacing(-1250),
    top: 'auto',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
  },
}));

const AriaLiveRegion = ({ id, message, isPolite = true, ...props }) => {
  const classes = useStyles();

  return (
    <Box
      id={`${id ? `${id}-` : ''}aria-live-region`}
      aria-live={isPolite ? 'polite' : 'assertive'}
      aria-atomic="true"
      className={`noTranslate ${classes.visuallyHidden}`}
      role="status"
      {...props}
    >
      {message}
    </Box>
  );
};

AriaLiveRegion.propTypes = {
  /**
   * Optional (but highly recommended) so `<AriaLiveRegion>` has a unique `id`.
   */
  id: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

export default AriaLiveRegion;
